import type { AppliedRule } from "@/lib/types";

/** Подпись правила в колонке Ads Manager (ТЗ ECG §15): «ECG · 5» — число
 *  сущностей под строкой, на которых правило действует; у правила уровня
 *  самой строки числа нет. */
export function ruleChipLabel(r: AppliedRule): string {
  return r.count == null ? r.name : `${r.name} · ${r.count}`;
}
